import { observer } from 'mobx-react-lite';

import './style.sass';

import { Page } from 'app/components/common/PageLayout';
import { CampaignsTable } from 'app/components/CampaignsTable';
import { Button } from 'app/components/common/Button';
import { useBreakpointType } from 'app/services/breakpoints';
import { CampaignsCardsList } from 'app/components/CampaignsCardsList';
import { useModel } from 'app/hooks/useViewModel';
import { CampaignsPageViewModel } from 'app/viewModels/pages/CampaignsPageViewModel';
import { Greetings } from 'app/components/common/Greetings';
import { AttentionMessage } from 'app/components/common/AttentionMessage';
import { CampaignsSearch } from 'app/components/CampaignsSearch';
import { CampaignsFiltersDropdown } from 'app/components/CampaignsFiltersDropdown';
import { CampaignsSortDropdown } from 'app/components/CampaignsSortDropdown';

export const CampaingsPage = observer(() => {
    const { isMobile } = useBreakpointType();
    const {
        campaigns,
        handleClickLoadMore ,
        hasMore,
        userRole,
        isAdmin,
        isLoading,
        setSearchString,
        activeFiltersModel,
        setFilter,
        sortByModel,
        setSortByMethod,
    } = useModel(CampaignsPageViewModel);

    const hasCampaigns = !!campaigns && !!campaigns.length;

    return (
        <Page className="campaings-page" isLoading={isLoading}>
            {isAdmin &&
                <div className="campaings-page__admin-panel">
                    <div className="left-wrapper">
                        <CampaignsSortDropdown
                            model={sortByModel}
                            onChange={setSortByMethod}
                        />

                        <CampaignsFiltersDropdown
                            model={activeFiltersModel}
                            onChange={setFilter}
                        />
                    </div>

                    <CampaignsSearch onSubmit={setSearchString}/>
                </div>
            }

            {hasCampaigns && (
                <>
                    {isMobile
                        ? <CampaignsCardsList campaigns={campaigns} userRole={userRole}/>
                        : <CampaignsTable campaigns={campaigns} userRole={userRole}/>
                    }
                    {hasMore && (
                        <div className="campaings-page__btn">
                            <Button
                                size="big"
                                colorType="primary-light"
                                text="Load more"
                                className='campaings-page__load-more-btn'
                                onClick={handleClickLoadMore}
                            />
                        </div>
                    )}
                </>
            )}

            {!hasCampaigns && (
                <div className="campaings-page__greetings">
                    {isAdmin
                        ? <AttentionMessage
                            title="No campaigns yet"
                            desc="Please wait until someone purchases a campaign."
                        />
                        : <Greetings />}
                </div>
            )}
        </Page>
    );
});
